export const isFilled = (value: string): boolean => value.trim() !== "";

export const isValidEmail = (value: string): boolean =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value,
  );

export const linkedInUrlPattern =
  /^(https?:\/\/)?((www|\w\w)\.)?linkedin.com\/((in\/[^/]+\/?)|(pub\/[^/]+\/((\w|\d)+\/?){3}))$/;

export const isValidLinkedInUrl = (value: string): boolean =>
  linkedInUrlPattern.test(value);
